import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Preloader from '@/components/UI/Preloader';
import FounderDetailCard from '@/components/Cards/FounderDetailCard';
import { getFounderDetail } from '@/store/services/userServices';
import { BackButton } from '@/components/UI/Buttons';
import { canGoBack } from '@/helpers/utils';
import { APP_LINKS } from '@/helpers/links';
import './index.scss';

const FounderDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  const getDetails = founderID => {
    setLoading(true);
    getFounderDetail(founderID).then(res => {
      setDetail(res?.success ? res.data : null);
      setLoading(false);
    });
  };

  useEffect(() => {
    getDetails(id);
  }, [id]);

  return (
    <div className="founder-detail-page">
      <div className="container-inner">
        <div className="founder-detail-page__back">
          <BackButton onClick={() => (canGoBack() ? navigate(-1) : navigate(APP_LINKS.founders))} />
        </div>
        {loading ? (
          <Preloader className="founder-detail-page__preloader" />
        ) : (
          <FounderDetailCard founderID={id} founder={detail} />
        )}
      </div>
    </div>
  );
};

export default FounderDetailPage;
